module.exports = __webpack_public_path__ + "static/img/img-home-cup-text.7f65e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-cup-text.png
// module id = Vy66
// module chunks = 1